import {
  Grid,
  IconButton,
  Paper,
  Snackbar,
  SnackbarContent,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ErrorOutlineRoundedIcon from "@material-ui/icons/ErrorOutlineRounded";
import React, { FunctionComponent, useState } from "react";
import { RouteComponentProps, withRouter, Redirect } from "react-router-dom";
import { useStore } from "../../store/index";
import { LoginForm } from "./LoginForm";
import { useLoginStyles } from "./useLoginStyles";
import loginBackground from "../../assets/images/loginbg.jpg";

const LoginComponent: FunctionComponent<RouteComponentProps<any>> = ({
  history: { push },
}) => {
  const styles = useLoginStyles();
  const [user, { login }] = useStore("auth", "user");
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const onSignin = async (credentials: {
    username: string;
    password: string;
  }) => {
    try {
      setIsLoading(true);
      await login(credentials);

      push("/");
    } catch (error:any) {
      setIsLoading(false);
      setError(error.error);
      console.log("At Login", error);
    }
  };
  if (user) {
    return <Redirect to="/" />;
  }

  return (
    <div className={styles.mainContainer}>
      <Snackbar
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={!!error}
        autoHideDuration={2000}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        onClose={() => setError(null)}
      >
        <SnackbarContent
          style={{ backgroundColor: "red" }}
          message={
            <span
              id="message-id"
              style={{
                display: "flex",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <ErrorOutlineRoundedIcon />
              {error}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="close"
              onClick={() => setError(null)}
            >
              <CloseIcon />
            </IconButton>,
          ]}
        />
      </Snackbar>
      <Grid
        container
        direction="row"
        alignItems="center"
        justify="center"
        style={{ flexGrow: 3 }}
      >
        <Grid item xs={12}>
          <img
            src={loginBackground}
            alt="loginBackground"
            style={{ height: "100vh" }}
            width="100%"
          />
        </Grid>
        <Grid item style={{ position: "absolute", zIndex: 1 }}>
          <Paper elevation={3} className={styles.paper}>
            <Grid container className={styles.credentialContainer}>
              <Grid item>
                <LoginForm onSignin={onSignin} isLoading={isLoading} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        justify="flex-end"
        alignItems="flex-start"
        // spacing={3}
        style={{
          bottom: 0,
          position: "absolute",
          left: 0,
          right: 0,
        }}
      >
        <Grid item style={{ paddingLeft: "1em", paddingBottom: "1em" }}>
          <Typography style={{ color: "#fff" }}>version 3.0.1</Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export const Login = withRouter(LoginComponent);
